.summary {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  align-items: flex-start;
}
.title {
  margin: 0;
}
.score {
  font-size: var(--tuna-typography-h2-fontSize);
  font-weight: 700;
}
.byTech {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}
.actions {
  display: flex;
  gap: var(--tuna-spacing-2);
}
